import React from 'react';
import reactLogo from '../assets/reactlogo.png';
import angularLogo from '../assets/angularlogo.png';
import htmlLogo from '../assets/htmllogo.png';
import cssLogo from '../assets/csslogo.png';
import jsLogo from '../assets/javascriptlogo.png';
import ionicLogo from '../assets/ioniclogo.png';
import nodeLogo from '../assets/nodejslogo.png';
import expressLogo from '../assets/expressjslogo.png';
import mongoLogo from '../assets/mongodblogopng.png';
import sqlLogo from '../assets/sqllogo.png';
import firebaselogo from '../assets/firebaselogo.png';
import postgreslogo from '../assets/Postgresqllogo.png';
import nextjslogo from '../assets/nextjslogo.png';
import tailwindcsslogo from '../assets/Tailwindcsslogo.png';
import pythonlogo from '../assets/pythonlogo.png';
import javalogo from '../assets/javalogo.png';
import postmanlogo from '../assets/postmanlogo.png';
import githublogo from '../assets/githublogo.png';
import phplogo from '../assets/phplogo.png';

function Skills() {
  const techStack = [
    { name: 'React', img: reactLogo },
    { name: 'Angular', img: angularLogo },
    { name: 'HTML', img: htmlLogo },
    { name: 'CSS', img: cssLogo },
    { name: 'JavaScript', img: jsLogo },
    { name: 'Ionic', img: ionicLogo },
    { name: 'Node.js', img: nodeLogo },
    { name: 'Express', img: expressLogo },
    { name: 'MongoDB', img: mongoLogo },
    { name: 'Firebase', img: firebaselogo },
    { name: 'Postgres', img: postgreslogo },
    { name: 'Next.js', img: nextjslogo },
    { name: 'Tailwind', img: tailwindcsslogo },
    { name: 'Python', img: pythonlogo },
    { name: 'Java', img: javalogo },
    { name: 'Postman', img: postmanlogo },
    { name: 'Github', img: githublogo },
    { name: 'Sql', img: sqlLogo },
    { name: 'Php', img: phplogo },
  ];

  return (
    <section className="skills" id="skills">
      <div className="skills-card">
        <h2>
          <span>Tech Stack</span>
        </h2>

        <div className="skills-horizontal">
          {techStack.map((tech) => (
            <div key={tech.name} className="tech-item">
              <img src={tech.img} alt={tech.name} />
              <p>{tech.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
export default Skills;
